import { UserPermissions } from '@agroone/entities'
import { CanActivateFn, Router } from '@angular/router'
import { inject } from '@angular/core'
import { map, switchMap } from 'rxjs'
import { PermissionService } from './permission.service'

export const permissionsGuard: CanActivateFn = (route) => {
  const permissionService = inject(PermissionService)
  const router = inject(Router)
  const requiredPermissions = (route.data?.['permissions'] as UserPermissions[] | undefined) ?? []

  return permissionService.hasAnyPermission$(requiredPermissions).pipe(
    switchMap((allowed) => {
      if (allowed) return [true]

      return permissionService
        .getFirstAllowedRoute$()
        .pipe(map((fallbackRoute) => router.createUrlTree([fallbackRoute ?? '/forbidden'])))
    }),
  )
}
